import ServiceQuestionModel from "@/models/lab/ServiceQuestionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ServiceQuestionCollection extends LabServiceCollection {
  model() {
    return ServiceQuestionModel;
  }

}
